import React, { Fragment } from 'react'
import { Timeline, Event } from "react-timeline-scribble";

const TimeLine = () => {
    return (
        <div className="main-road-map" id="roadmap">
            <div className="container">
                <div className="row">
                    <div className="col-md-10 col-md-offset-1">
                        <Fragment>
                            <h2>SAFEPIZZA ROADMAP</h2>
                            <Timeline>
                                <Event interval={"Q2"}>
                                    <ul className="road-ul">
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >Inception CIRCA: April 17, 2021</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >Deployment BscScan : <a href="https://bscscan.com/token/0x72eb1afddb5652e0f5c7b9a6cc1c3241348b16c6">bscscan.com/token/0x72eb1afddb5652e0f5c7b9a6cc1c3241348b16c6
                                            Contract Address: 0x72eb1afddb5652e0f5c7b9a6cc1c3241348b16c6</a></li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >Token Name: SafePizza</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >Token Symbol: PIZZA</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >Total Supply: 100,000,000,000,000,000 (100 Quadrillion)</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >Decimals: 9 units</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >LP Burned</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >Ownership of Contract Renounced</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >Logo on PancakeSwap</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >Set up Media links:</li>
                                        <ul className="sub-ul"
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >
                                            <li><a href="https://t.me/safepizza">Telegram: t.me/safepizza</a></li>
                                            <li><a href="https://www.safepizza.finance/">Website: safepizza.finance (Will migrate to safe-pizza.com – new design)</a></li>
                                            <li><a href="https://www.facebook.com/safepizza">Facebook.com/SafePizza</a></li>
                                            <li><a href="https://www.instagram.com/safepizzafinance/">Instagram.SafePizzaFinance</a></li>
                                            <li><a href="https://discord.com/invite/p8HZZ55GSk">Discord: https://discord.com/invite/p8HZZ55GSk</a></li>
                                        </ul>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >Logo on TrustWallet</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >Whitepaper</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >List CoinMarketCap.com</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >List CoinGecko.com</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >New Team Arrival</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >New Website Domain: Safe-Pizza.com (new design)</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >Ads in Facebook, Digital GiveAways (Twitter, Instagram, Tiktok, FB)</li>
                                    </ul>
                                </Event>
                                <Event interval={"Q3"}>
                                    <ul className="road-ul">
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >Lite Paper and Audit</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >Phase 2 Marketing Campaign / RD / Exchange List</li>
                                        <ul className="sub-ul"
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >
                                            <li>USA Market (ground game) – SHOP Merchandise website link <a href="https://www.safepizza.finance/">(safepizza.pizza)</a></li>
                                            <li>Ads in Facebook, Poocoin, etc., More Digital GiveAways (Twitter, Instagram, Tiktok, FB)</li>
                                        </ul>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >YouTube Channel: SafePizza Token</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >Twitch.TV Channel: SafePizza Token (AMA)</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >Marketing and Exchange Donation</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >SafePizza Food Banks – #Feed the World Charity Donations – Community Donation</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >PizzaTracker</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >Exchange Listing</li>

                                        <li><a href="https://www.linkedin.com/company/safepizzaofficial" target="_blank">Linkedin</a></li>
                                        <li>Promotions on Twitter, Telegram, Facebook, Instagram, TikTok</li>
                                        <li>GAMES on Website Available</li>
                                        <li>PIZZA CHART</li>
                                        <li>WhitePaper Revised</li>
                                        <li>Audit</li>
                                        <li>Updated New Logo on Trust Wallet</li>
                                        <li>Updated New Logo on CoinGecko</li>
                                        <li>Updated New Logo on CoinMarketCap</li>
                                        <li>Updated New Logo on Poocoin</li>
                                        <li>Updated Features on Marketing Page on Website. Donations Widget</li>
                                        <li>Updated Features on Charity Page on Website. Donations Widget NowPayments</li>
                                        <li>Updated Team Page on Website- Team Roster</li>
                                        <li>Listed on COINSBIT EXCHANGE</li>

                                    </ul>
                                </Event>
                                <Event interval={"Q4"}>
                                    <ul className="road-ul">
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >Charity Donations Allocation</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >More Exchange Listing</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >NFT Development</li>
                                        <li
                                            data-aos="fade-up"
                                            data-aos-delay="30"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out-cubic"
                                        >NFT Design Contest</li>
                                    </ul>
                                </Event>
                            </Timeline>
                        </Fragment>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TimeLine
